export const SSH_TUNNEL_STAGES = [
    'resolve',
    'tcp',
    'handshake',
    'auth',
    'forward',
];
export const isSshTunnelErrorData = (data) => typeof data === 'object' &&
    data !== null &&
    'stage' in data &&
    typeof data.stage === 'string' &&
    SSH_TUNNEL_STAGES.includes(data.stage);
export const WAREHOUSE_CONNECTION_HOP_LABELS = {
    resolve: 'Resolve SSH host',
    tcp: 'Reach SSH port',
    handshake: 'SSH handshake',
    auth: 'Key accepted',
    forward: 'Bastion reaches database',
    database: 'Database login and test query',
};
//# sourceMappingURL=sshTunnel.js.map